module.exports = "/_next/static/images/FrancescoDiLorenzo-54d06b0fd385e1f04713bacb255d56d7.png";